/**
 * State
 * @type {Object}
 */
const state = {
    data: null,
    change: new Date(),
    messages: [],
    chatter: ''
}

/**
 * Getters
 * @type {Object}
 */
const getters = {
    isLoaded: (state) => (id) => {
        return ( state.data && state.data.id == id );
    },
    id: (state) => state.data ? state.data.id : null,
    kenmerk: (state) => state.data ? state.data.kenmerk : ''
}

/**
 * Actions
 * @type {Object}
 */
const actions = {

    load({commit, getters}, id) {

        return new Promise( (resolve, reject) => {

            if ( getters.isLoaded(id) ) {
                resolve();
            }
            else {
                this.$xhr.get('/api/request-detail/' + id + '/').then( ({result}) => {
                    commit('add', result);
                    resolve();
                }).catch(reject)
            }
        });
    },

    reload({commit, getters}) {

        return new Promise( (resolve, reject) => {

            if ( getters.id ) {
                this.$xhr.get('/api/request-detail/' + getters.id + '/').then( ({result}) => {
                    commit('add', result);
                    resolve();
                }).catch(reject)
            }
        });
    },

    messages({commit}, {id, assignment}) {

        return new Promise( (resolve, reject) => {
            let params = {};

            if ( assignment ) {
                params.opdracht = assignment;
            }

            this.$xhr.get('/api/request-detail/' + id + '/messages/', params).then( ({result}) => {
                commit('messages', result);
                resolve();
            }).catch(reject);
        });
    },

    markMessagesAsRead({commit}, {id, assignment}) {
        return new Promise( (resolve, reject) => {
            let params = {};

            if ( assignment ) {
                params.opdracht = assignment;
            }
            this.$xhr.get('/api/request-detail/' + id + '/message-read', params).then( ({result}) => {
                resolve();
            }).catch(reject)
        })
    },

    addMessage({commit}, {id, text, assignment}) {

        return new Promise( (resolve, reject) => {

            let params = {body: text};

            if ( assignment ) {
                params.opdracht = assignment;
            }

            this.$xhr.put('/api/request-detail/' + id + '/message/', params).then( ({result}) => {
                commit('addMessage', result);
                commit( ( assignment ) ? 'updateAssignmentCount' : 'updateCount', assignment);

                resolve();
            }).catch((e) => {
                console.log(e);
                reject();
            });
        });
    },

    removeFile({commit}, id) {
        commit('removeFile', id);
    },

    addFileTranslation({commit}, {translation, files}){
        commit('addFileTranslation', {translation, files});
    },

    removeFileTranslation({commit}, {translation, id}){
        commit('removeFileTranslation', {translation, id});
    },

    addTranslators({commit, dispatch}, {language, translators}) {
        dispatch('reload').then( () => {}).catch((e) =>{ console.alert(e) });
        //commit('addTranslators', {language, translators});
    },

    changeAssignment({commit, dispatch}, change) {
        dispatch('reload').then( () => {}).catch((e) =>{ console.alert(e) });
        //commit('changeAssignment', change);
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {

    add(state, data ) {
        state.data = data;
    },

    messages(state, data) {
        state.messages = data.messages;
        state.chatter = data.name;
    },

    addMessage(state, message){
        state.messages.push(message);
    },

    addTranslators(state, {language, translators}) {
        if ( state.data.vertalingen ) {
            let index = state.data.vertalingen.findIndex( l => l.id == language.id );

            if ( index >= 0) {
                state.data.vertalingen[index].opdrachtnemers = state.data.vertalingen[index].opdrachtnemers.concat(translators);
            }
        }
    },

    changeAssignment(state, change) {

        if ( change.id ) {

            state.data.vertalingen.forEach( (translation, vindex) => {
                if (translation.opdrachtnemers) {
                    translation.opdrachtnemers.forEach( (assignment, aindex) => {
                        if ( assignment.id == change.id) {
                            Object.keys(change).forEach( (key) => {
                                state.data.vertalingen[vindex].opdrachtnemers[aindex][key] = change[key];
                            });
                        }
                    })
                }
            });
        }
    },

    removeFile(state, id){
        let index = state.data.media.find( m => m.id == id );
        state.data.media.splice(index, 1);
    },

    addFileTranslation(state, {translation, files}){
        state.data.vertalingen.forEach( (t, vindex) => {
            if (t.opdrachtnemers) {
                t.opdrachtnemers.forEach( (a, aindex) => {
                    if ( a.id == translation.id) {
                        state.data.vertalingen[vindex].opdrachtnemers[aindex].media = state.data.vertalingen[vindex].opdrachtnemers[aindex].media.concat(files);
                    }
                })
            }
        });
    },

    removeFileTranslation(state, {translation, id}){
        state.data.vertalingen.forEach( (t, vindex) => {
            if (t.opdrachtnemers) {
                t.opdrachtnemers.forEach( (a, aindex) => {
                    if ( a.id == translation.id) {
                        let index = state.data.vertalingen[vindex].opdrachtnemers[aindex].media.findIndex( m => m.id == id);

                        if ( index >= 0 ){
                            state.data.vertalingen[vindex].opdrachtnemers[aindex].media.splice(index, 1);
                        }
                    }
                })
            }
        });
    },

    updateCount(state) {
        if ( state.data ){
            state.data.berichten_count++;
        }
    },

    updateAssignmentCount(state, assignment) {
        if ( state.data ){
            state.data.vertalingen.forEach( (t) => {
                if (t.opdrachtnemers) {
                    t.opdrachtnemers.forEach( (a, aindex) => {
                        if ( a.id == assignment) {
                            a.berichten_count++;
                        }
                    });
                }
            });
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
